import React, { Component } from 'react';
import ReactTable from 'react-table';
import PropTypes from 'prop-types';
import moment from 'moment';

import { routes } from '../../../../routes';
import { debounce } from '../../../../util/helpers';

import { apiAllMemberships } from '../../../../api/membership';
import Card from '../../../../components/Card';

const propTypes = {
  history: PropTypes.object,
};

class List extends Component {
  state = {
    data: [],
    loading: true,
    pages: null,
  };

  columns = [
    { id: 'users.first_name', Header: 'First Name', accessor: 'firstName' },
    { id: 'users.last_name', Header: 'Last Name', accessor: 'lastName' },
    {
      id: 'created_at',
      Header: 'Requested On',
      accessor: 'createdAt',
      Cell: (date) => moment(date.value).format('MM/DD/YYYY'),
      Filter: <noscript />,
    },
    { id: 'products.name', Header: 'Type', accessor: 'name' },
  ];

  getMemberships = ({ pageSize, page, sorted, filtered }) => {
    this.setState({ loading: true });

    apiAllMemberships({ pageSize, page: page + 1, sorted, filtered }).then((resp) => {
      const responseData = resp.data;
      this.setState({ loading: false, data: responseData.data, pages: responseData.lastPage });
    });
  };

  render() {
    const { data, loading, pages } = this.state;

    return (
      <div>
        <div className="row">
          <div className="col">
            <Card>
              <Card.Header compact>Membership Requests</Card.Header>
              <Card.Body>Choose an membership request below to review it</Card.Body>
            </Card>
          </div>
        </div>
        <ReactTable
          className="mt-4 -striped -highlight clickable card"
          data={data}
          columns={this.columns}
          pages={pages}
          loading={loading}
          manual
          onFetchData={debounce(this.getMemberships, 300)}
          filterable
          defaultPageSize={10}
          getTrProps={(state, rowInfo) => {
            return {
              onClick: (e, handleOriginal) => {
                this.props.history.push(routes.admin.memberships.reviewBuilder(rowInfo.original.id));

                if (handleOriginal) {
                  handleOriginal();
                }
              },
            };
          }}
          FilterComponent={({ filter, onChange }) => (
            <input
              type="text"
              className="form-control"
              placeholder="Filter..."
              value={filter ? filter.value : ''}
              onChange={(event) => onChange(event.target.value)}
            />
          )}
        />
      </div>
    );
  }
}

List.propTypes = propTypes;

export default List;
